import { render, staticRenderFns } from "./expectedIncome.vue?vue&type=template&id=29555134&scoped=true&"
import script from "./expectedIncome.vue?vue&type=script&lang=js&"
export * from "./expectedIncome.vue?vue&type=script&lang=js&"
import style0 from "./expectedIncome.vue?vue&type=style&index=0&id=29555134&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29555134",
  null
  
)

export default component.exports